module.exports = __webpack_public_path__ + "assets/able-logo.b99149a3.svg";